import { useMemo } from "react";
import styled from "styled-components";
import { PAGES_QTDE } from "../utils";

interface PaginationProps {
    total: number;
    page: number;
    size: number;
    onChange: (page: number, size: number) => any;
}

function Pagination({ total, page, size, onChange }: PaginationProps) {
    const totalPages = Math.ceil(total / size);

    const pages = useMemo(() => {
        const maxVisible = 5;
        let start = Math.max(1, page - 2);
        let end = Math.min(totalPages, start + maxVisible - 1);

        if (end - start < maxVisible - 1) {
            start = Math.max(1, end - maxVisible + 1);
        }

        return Array.from(
            { length: end - start + 1 },
            (_, i) => start + i
        );
    }, [page, totalPages]);

    return (
        <ContainerPagination>
            {
                totalPages > 1 && (
                    <ContentPages>
                        <PageLink
                            disabled={page === 1}
                            onClick={() => onChange(page - 1, size)}
                        >
                            &lt;
                        </PageLink>

                        {pages.map(p => (
                            <PageLink
                                key={p}
                                onClick={() => onChange(p, size)}
                                style={{
                                    background: p === page ? "#1890ff" : "white",
                                    color: p === page ? "#fff" : "#666",
                                    borderColor: p === page ? "#1890ff" : "#e0e0e0",
                                }}
                            >
                                {p}
                            </PageLink>
                        ))}

                        <PageLink
                            disabled={page === totalPages}
                            onClick={() => onChange(page + 1, size)}
                        >
                            &gt;
                        </PageLink>
                    </ContentPages>

                )
            }

            <SelectStyled
                value={size}
                onChange={(e) => onChange(1, Number(e.target.value))}
            >
                {PAGES_QTDE.map(item => (
                    <option key={item.value} value={item.value}>
                        {item.label}
                    </option>
                ))}
            </SelectStyled>
        </ContainerPagination>
    );
}


const ContainerPagination = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
`;

const ContentPages = styled.div`
    display: flex;
    gap: 4px;
    align-items: center;
`;

const PageLink = styled.button`
    padding: 6px 12px;
    border: 1px solid #e0e0e0;
    background: white;
    color: #666;
    text-decoration: none;
    border-radius: 4px;
    font-size: 14px;
    cursor: pointer;
    transition: all 0.2s;

    :disabled {
        opacity: 0.5;
        cursor: not-allowed;
    }
`;

export const SelectStyled = styled.select`
  padding: 6px 8px;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  font-size: 14px;
  background: white;
  color: #666;
  cursor: pointer;
`;


export default Pagination;